export const DYNAMIC_COLORS = [
  'purple',
  'orange',
  'green',
  'emerald',
  'red',
  'neutral',
  'blue',
  'sky',
  'yellow',
  'gray',
  'amber',
  'indigo',
];

export const DYNAMIC_LEVELS = ['50', '100', '200', '300', '400', '500', '600', '700', '800', '900'];
